import React from 'react';
import PropTypes from "prop-types";
import { Chip } from "@mui/material";

function getContrastYIQ(hexcolor) {
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
}
const StyledChip = ({ label, onClick, sx, defaultColor,handleClick, spacing, ...restProps }) => {

    // const color = colorForBgColor(defaultColor);
    const color = getContrastYIQ(defaultColor);

    return (
        <Chip
            label={label}
            sx={{
                bgcolor: defaultColor,
                color: color,
                "&:hover": {backgroundColor: defaultColor },
                ...sx,
            }}
            onClick={(event) => handleClick(event)}
            {...restProps}
        />
    )
};

StyledChip.defaultProps = {
    defaultColor: "#DDDDDD"
};

StyledChip.propTypes = {
    onClick: PropTypes.func,
    defaultColor: PropTypes.string,
};

export default StyledChip;
